
import {useEffect,useState,useMemo,useContext} from 'react';

import { IonCheckbox, IonInput,IonSelect,IonSelectOption,IonItem,IonLabel,IonRow } from "@ionic/react";
import './NullableMultiSelect.css';
import { Json } from '../common/types';

const NullableMultiSelect: React.FC<{
    value:string,
    values:String[],
    options?:{value:string,label:string}[],
    setValue:(v:string)=>void,
    required?:boolean
  }> = ({value,values,options,setValue,required}) => {
    const selectOptions = options || values.map(value => ({value:String(value), label:String(value)}));

    if (required){
      return <IonSelect multiple value={value?value.split(','):value} onIonChange={(e) => setValue(e.detail.value.join(',')) }>
      {
      selectOptions.map((option,i:any)=>{
          return <IonSelectOption key={i} value={option.value}>{option.label}</IonSelectOption>
      })
      }
      </IonSelect>
    }else{
      return<>
      <IonSelect multiple value={value? value.split(','):value} onIonChange={(e) =>e.detail.value==null?"":(value !== e.detail.value.join(',')  && setValue(e.detail.value.join(','))) }>
      {
      selectOptions.map((option,i:any)=>{
          return <IonSelectOption key={i} value={option.value}>{option.label}</IonSelectOption>
      })
      }
      </IonSelect>
      <IonCheckbox className='after' slot="end" checked={!value} onIonChange={e => {
          if (e.detail.checked){
            setValue(null);
          }
            // setValue( e.detail.checked?null:"");
          }} style={{}} ></IonCheckbox>
      </>;
    }


    


};



export default NullableMultiSelect;




